import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import './Category.css'
import img_back from '../../img/y-copy.png'
import cate_log from '../../img/category.png'
import { getCatedata } from '../../api'
import getNum from '../../method/method'
import starsScore from '../../method/start'
import { insert_adv, remove_adv } from '../../method/addadv'
import Footer from '../Home/Footer/Footer'
import { iframeLoad } from '../../method/analytics'

export default function Catatory() {
  const [data, setData] = useState([])
  const { search } = useLocation()
  let cataname = search.slice(6)
  /* 返回上一页 */
  const goback = () => {
    window.location = '/'
  }

  // 跳转详情
  //   const goDetails = (para) => {
  //     window.location = "/page/details?gid=" + para;
  //   };

  useEffect(() => {
    //获取分类列表数据
    const getdata = () => {
      getCatedata(search).then(res => {
        setData(res.data.list)
      })
    }
    document.getElementsByTagName('body')[0].style.overflow = 'auto'
    getdata()

    if ((window.law_ntv_ad1, window.law_ntv_ad2)) {
      insert_adv('adv_1')
      insert_adv('adv_2')
      // 广告加载 上传分析
      var pageLoadSecond = new Date().getTime()
      iframeLoad(pageLoadSecond)

      return () => {
        remove_adv('adv_1')
        remove_adv('adv_2')
      }
    }
  }, [search])

  return (
    <div className="catagory">
      <div className="catename">
        <img src={img_back} alt="" onClick={goback} className="back" />
        <img src={cate_log} alt="" className="log" />
        <h1>{cataname}</h1>
      </div>

      <div className="gl-content">
        {/* 广告一 *************************** */}
        <div className="adv_box">
          <p>Advertisement</p>
          <div id="adv_1" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
        </div>

        {/* 游戏列表区 */}
        <ul>
          {data?.map(item => (
            <li key={item.gid}>
              <a href={'/page/details?gid=' + item.gid} className="dis_a">
                <div>
                  <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                  <div>
                    <h3>{item.name}</h3>
                    <p>
                      {starsScore(item.score)} {item.score}
                    </p>
                    <span>{getNum(item.count)}</span>
                  </div>
                </div>

                <span>play</span>
              </a>
            </li>
          ))}
        </ul>

        {/* 广告二 *************************** */}
        <div className="adv_box">
          <p>Advertisement</p>
          <div id="adv_2" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}
